// Generate tooltip data for theme nodes (similar to Chart.js format)
export const createThemeTooltipData = (node, formatCurrency) => {
  if (node.id.startsWith('theme-')) {
    return {
      title: 'Social Value Theme',
      items: [{ label: 'Theme', value: node.label }]
    }
  }

  if (node.id.startsWith('out-')) {
    return {
      title: 'Social Criteria',
      items: [{ label: 'Social Criteria', value: node.label }]
    }
  }

  if (node.id.startsWith('imp-')) {
    // Extract impact value and stakeholder count from the original theme data
    const impactValue = node.label // This is the formatted currency
    const stakeholderText = node.secondaryLabel // This is the stakeholder count text

    return {
      title: 'Impact Details',
      items: [
        { label: 'Social Value', value: impactValue },
        { label: 'Stakeholders', value: stakeholderText }
      ]
    }
  }

  return null
}

// Generate tooltip data for the main SV Theme node
export const createMainThemeTooltipData = () => {
  return {
    title: 'Social Value Theme',
    items: [
      {
        label: 'Description',
        value: 'Central hub connecting all social value themes to their social criteria and impacts'
      }
    ]
  }
}
